import React from "react";
import {ProductModel} from "../../interfaces";
import Imgix from "react-imgix";
import {useAppDispatch, useAppSelector} from "../../DAL/store";
import StarRating from "../../../../ui/rating/star-rating";
import {HidePluginView, StopPropagation} from "../../services/logic-helper";
import CloseIcon from "../../../../ui/svg/common/close";

interface IPluginViewSortOptionsProps {
    product : ProductModel;
}

export const PluginViewMobile = (props : IPluginViewSortOptionsProps) => {

    const ImgCdnDomain = useAppSelector((store) => store.ImgCdnDomain);
    const dispatch = useAppDispatch();

    return (
        <>{props.product !== undefined &&
                <div className="absolute plugin-view"  onClick={StopPropagation}>
                    <div className={`text-black h-full`}>
                        <div className={`plugin-view-container h-full`} >
                            <div className={`plugin-image-container flex items-center justify-center py-10  h-full relative`}>
                                <div className="absolute top-0 w-full flex  justify-end">
                                    <button type="button" className="p-6" onClick={() => HidePluginView(dispatch)}>
                                        <CloseIcon width={"16px"} color={"black"} />
                                    </button>
                                </div>
                                <Imgix
                                    className="plugin-view-image"
                                    src={ ImgCdnDomain + props.product.thumb }
                                    width={202}
                                    htmlAttributes={{
                                        alt: `Image for ${ props.product.documentName }`,
                                        loading: 'lazy',
                                    }}
                                />
                            </div>
                            <div className="p-10 bg-white h-full">
                                <div className="font-bold text-lg">{props.product.documentName}</div>
                                <div className="pt-4">{props.product.documentPageDescription}</div>
                                <StarRating
                                    // @ts-ignore
                                    rating={ props.product.rating }
                                    // @ts-ignore
                                    reviews={ props.product.reviewsTotal }
                                    url={ props.product.documentUrlPath }
                                    className="pt-2"
                                    gaEventName={ 'Click Reviews' }
                                    gaEventValue={ props.product.documentName }
                                />
                            </div>

                        </div>
                    </div>
                </div>
        }</>
    )
};